import React, { useRef, useState } from 'react';
import { Box, Checkbox, FormControlLabel, FormGroup, IconButton, List, ListItem, ListItemText, Stack, Tooltip, Typography } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import InfoIcon from '@mui/icons-material/Info';
import { featuredRequirement } from '../../_helpers/reusablefunctions/eligibleRequirement';

export default function ReusableImageComponent({
  selectedFile,
  handleFileChange,
  disabled = false,
  imageSrc = null,
  imageAlt = 'Uploaded',
  tooltipTitle = "Update cover image",
  imageBannerRatioText,
  helperText,
  error,
  selectedOptions,
  setSelectedOptions
}) {
  const fileInputRef = useRef(null);
  const featureList = featuredRequirement();
  const coverArtData = {
    fileFormat: ['JPG', 'PNG'],
    imageDimensions: {
      dimension: imageBannerRatioText,
      maxFileSizeMB: 10,
    },
    aspectRatio: 'Square',
    restrictions: {
      prohibitedContent: [
        'Social media logos or handles',
        'Brand logos',
        'Any text except for artist names and/or the name of the release',
      ],
    },
  };


  const triggerFileInput = () => {
    if (!disabled && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  const handleChange = (event, option) => {
    const { checked } = event.target;

    const updatedOptions = checked
      ? [...selectedOptions, option]
      : selectedOptions.filter(item => item.id !== option.id);

    setSelectedOptions(updatedOptions);
  };
  return (
    <Box sx={{
      padding: '20px', display: 'flex', gap: 3, alignItems: 'flex-start', flexDirection: { xs: 'column', md: 'column' }
    }}>
      <Box sx={{ width: { xs: '100%', sm: '100%', md: '100%' } }}>
        {(!selectedFile && !imageSrc) ? (
          <Box
            onClick={triggerFileInput}
            sx={{
              border: error ? '2px dashed #d32f2f' : '2px dashed rgba(0,0,0,0.2)',
              borderRadius: '8px',
              padding: '2rem',
              textAlign: 'center',
              cursor: disabled ? 'not-allowed' : 'pointer',
              backgroundColor: '#f9f9f9',
            }}
          >
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              ref={fileInputRef}
              disabled={disabled}
              style={{ display: 'none' }}
            />
            <p className='text-primary'><UploadFileIcon fontSize='large' /></p>
            <Box>
              <Box><span className='text-primary fs-14'>Click to upload </span></Box>
              <Box className='fs-14'><span>or drag and drop </span></Box>
            </Box>
            <p className='text-secondary' style={{ fontSize: '0.8rem' }}>JPG, JPEG, PNG (max. 10MB)</p>
          </Box>
        ) : (
          <Box className="mb-3" style={{
            position: 'relative',
            border: error ? '2px dashed #d32f2f' : '2px dashed rgba(0,0,0,0.2)',
          }}>
            <img
              src={selectedFile ? URL.createObjectURL(selectedFile) : imageSrc}
              alt={imageAlt}
              style={{ borderRadius: "5px", width: '100%', height: '14rem' }}
            />
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              ref={fileInputRef}
              disabled={disabled}
              style={{ display: 'none' }}
            />
            {!disabled && (
              <Box onClick={triggerFileInput}>
                <Tooltip title={tooltipTitle} arrow>
                  <span>
                    <button style={{ position: 'absolute', top: '10px', right: '15px' }} className='gn-btn-icononly'>
                      <PhotoCameraIcon style={{ background: "white", borderRadius: "10px" }} />
                    </button>
                  </span>
                </Tooltip>
              </Box>
            )}
          </Box>
        )}
        {error && <Typography variant='caption' color="error" data-field-error="true">
          {helperText}
        </Typography>}
      </Box>

      <Box sx={{ p: 0, m: 0 }}>
        <Typography variant="subtitle1" sx={{ mb: 0 }}>
          Please note that the cover art must adhere to the following requirements:
        </Typography>
        <List disablePadding>
          <ListItem disableGutters sx={{ p: 0, m: 0 }}>
            <ListItemText
              sx={{ m: 0 }}
              secondary={`File Format: ${coverArtData.fileFormat.join(', ')}`}
            />
          </ListItem>

          <ListItem disableGutters sx={{ p: 0, m: 0 }}>
            <ListItemText
              sx={{ m: 0 }}
              secondary={`Image Dimensions: ${coverArtData.imageDimensions.dimension}, Max size: ${coverArtData.imageDimensions.maxFileSizeMB}MB`}
            />
          </ListItem>

          <ListItem disableGutters sx={{ p: 0, m: 0 }}>
            <ListItemText sx={{ m: 0 }} secondary={`Aspect Ratio: ${coverArtData.aspectRatio}`} />
          </ListItem>

          <ListItem disableGutters sx={{ p: 0, m: 0, pt: 2 }}>
            <ListItemText sx={{ m: 0 }} primary="Request Banner Placement" />
          </ListItem>
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap', mt: 1 }}>
            {featureList.map((option) => (
              <ListItem key={option.id} disableGutters dense sx={{ display: 'flex', flexDirection: 'row', p: 0, m: 0, width: 'auto' }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedOptions.some(item => item.id === option.id)}
                      onChange={(e) => handleChange(e, option)}
                      name={option.Name}
                    />
                  }
                  label={
                    <Stack direction="row" alignItems="center" spacing={0.5}>
                      <Typography variant="body2">{option.Name}</Typography>
                      {option.helperText && (
                        <Tooltip title={option.helperText} arrow>
                          <IconButton size="small">
                            <InfoIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      )}
                    </Stack>
                  }
                />
              </ListItem>
            ))}</Box>

          {/* {coverArtData.restrictions.prohibitedContent.map((item, index) => (
            <ListItem key={index} disableGutters dense sx={{ p: 0, m: 0 }}>
              <ListItemText sx={{ m: 0 }} secondary={`• ${item}`} />
            </ListItem>
          ))} */}
        </List>
      </Box>
    </Box>
  );
}
